var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"showmore-btn",attrs:{"href":"#work"}},[_c('i',{staticClass:"fas fa-chevron-down"})])}]

export { render, staticRenderFns }